import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Toast } from 'primereact/toast'
import { popupIcon } from 'Assets/Icons'
import DialogUIModal from 'Components/UIComponent/DialogUIModal'
import apiAdapterCoffeeWeb from 'Services/apiAdapter_CoffeeWeb'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'

export default function Uganda({ swapReport, setLoading, mockUgandaData, mockUgandaModal, mockModalType, createMonthRange, checkForUserAccess, reportName, menuLock }) {
  const { t } = useTranslation()
  const toast = useRef(null)
  const userDetails = getLocalUserDetails()

  const [fetchedData, setFetchedData] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [currentData, setCurrentData] = useState({})
  const [previousData, setPreviousData] = useState({})
  const [currentYear, setCurrentYear] = useState('')
  const [previousYear, setPreviousYear] = useState('')
  const [modalType, setModalType] = useState(null)
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null)

  useEffect(() => {
    fetchData()

    if (mockUgandaData) {
      setFetchedData(mockUgandaData)
      setShowModal(mockUgandaModal)
      setModalType(mockModalType)
    }
  }, [])

  const fetchData = async () => {
    setLoading(true)

    try {
      const response = await apiAdapterCoffeeWeb.getDataByReportName({ reportName })

      setFetchedData(response.data)
    } catch (error) {
      // console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const calculateTotals = (countryCertifiedData) => {
    const totals = {
      ARABICA: 0,
      ROBUSTA: 0
    }

    countryCertifiedData.forEach(({ ARABICA, ROBUSTA }) => {
      totals.ARABICA += Number(ARABICA) || 0
      totals.ROBUSTA += Number(ROBUSTA) || 0
    })

    return totals
  }

  const convertMTToBags = (valueInMT) => {
    if (valueInMT === '' || Number.isNaN(Number(valueInMT))) {
      return ''
    }
    const result = (valueInMT * 1000) / 60

    return Math.round(result) || ''
  }

  const valueForBags = (valueInMT) => {
    if (valueInMT === '' || Number.isNaN(Number(valueInMT))) {
      return ''
    }

    return valueInMT || ''
  }

  const convertToMillion = (value) => {
    if (value === '' || Number.isNaN(Number(value))) {
      return ''
    }

    const result = value / 60000

    return result.toFixed(4)
  }

  const calculateTotalsWithMonth = (data) => {
    const totals = {
      ARABICA: 0,
      ROBUSTA: 0,
      MONTH: ''
    }

    data.forEach(({ ARABICA, ROBUSTA, MONTH }) => {
      totals.ARABICA += Number(ARABICA) || 0
      totals.ROBUSTA += Number(ROBUSTA) || 0

      if (MONTH) {
        totals.MONTH = MONTH
      }
    })

    return totals
  }

  const getTextColor = (value) => {
    if (value === 0) {
      return 'neutral'
    }
    if (value > 0) {
      return 'positive'
    }

    return 'negative'
  }

  const displayValue = (value) => {
    if (value === null || value === undefined || value === 0) {
      return ''
    }

    if (swapReport === 'Metric Tons') {
      return valueForBags(Math.round(value)).toLocaleString()
    }

    if (swapReport === '60 KG Bags') {
      return convertMTToBags(value).toLocaleString()
    }

    if (swapReport === 'Millions Bags') {
      return convertToMillion(value)
    }

    return valueForBags(value).toLocaleString()
  }

  const showMonthValueModal = (currentIndex, selectedYear) => {
    const filteredData = fetchedData.find(({ year }) => year === selectedYear)

    const selectedIndex = fetchedData.findIndex(({ year }) => year === selectedYear)

    const nextData = selectedIndex !== -1 && selectedIndex + 1 < fetchedData.length ? fetchedData[selectedIndex + 1] : null

    if (!filteredData || !nextData) {
      toast.current.show({ severity: 'error', summary: t('NO_DATA'), detail: t('NO_DATA_FOR_PREVIOUS_YEAR'), life: 3000 })

      return
    }

    const currentYearData = filteredData?.report[currentIndex]
    const previousYearData = nextData?.report[currentIndex]

    const currentYearValue = filteredData?.year.split(' : ')[1]
    const previousYearValue = nextData?.year.split(' : ')[1]

    setCurrentData(currentYearData)
    setPreviousData(previousYearData)
    setCurrentYear(currentYearValue)
    setPreviousYear(previousYearValue)
    setModalType('month')

    if (currentYearData?.ARABICA !== '' && currentYearData?.ROBUSTA !== '' && previousYearData?.ARABICA !== '' && previousYearData?.ROBUSTA !== '') {
      setShowModal(true)
    } else {
      setShowModal(false)
      toast.current.show({ severity: 'error', summary: t('NO_DATA'), detail: t('NO_DATA_FOR_SELECTED_YEAR'), life: 3000 })
    }
  }

  const showTotalValueModal = (selectedYear) => {
    const filteredData = fetchedData.find(({ year }) => year === selectedYear)

    const selectedIndex = fetchedData.findIndex(({ year }) => year === selectedYear)

    const nextData = selectedIndex !== -1 && selectedIndex + 1 < fetchedData.length ? fetchedData[selectedIndex + 1] : null

    if (!filteredData || !nextData) {
      toast.current.show({ severity: 'error', summary: t('NO_DATA'), detail: t('NO_DATA_FOR_PREVIOUS_YEAR'), life: 3000 })

      return
    }

    const totalValue = []

    const updateData = filteredData?.report.filter((ele) => ele.ARABICA && ele.ROBUSTA)

    for (let i = 0; i < updateData.length; i++) {
      const elementCopy = { ...nextData?.report[i] }

      totalValue.push(elementCopy)
    }

    if (filteredData && nextData) {
      const currentYearTotal = calculateTotalsWithMonth(updateData)
      const previousYearTotal = calculateTotalsWithMonth(totalValue)

      const currentYearValue = filteredData?.year.split(' : ')[1]
      const previousYearValue = nextData?.year.split(' : ')[1]

      setCurrentData(currentYearTotal)
      setPreviousData(previousYearTotal)

      setCurrentYear(currentYearValue)
      setPreviousYear(previousYearValue)
      setModalType('total')

      if (currentYearTotal && previousYearTotal) {
        setShowModal(true)
      }
    }
  }

  const handleMouseEnter = (index) => {
    setHoveredRowIndex(index)
  }

  const handleMouseLeave = () => {
    setHoveredRowIndex(null)
  }

  const comparisonTableData = () => {
    if (!currentData || !previousData) {
      return null
    }

    const sumOfCurrentReports = currentData ? Number(currentData.ARABICA) + Number(currentData.ROBUSTA) : 0
    const sumOfPreviousReports = previousData ? Number(previousData.ARABICA) + Number(previousData.ROBUSTA) : 0

    const difference = {
      arabica: Number(currentData.ARABICA) - Number(previousData.ARABICA) || 0,
      robusta: Number(currentData.ROBUSTA) - Number(previousData.ROBUSTA) || 0,
      total: sumOfCurrentReports - sumOfPreviousReports
    }

    const percentageDifference = {
      arabica: previousData.ARABICA ? ((difference.arabica / Number(previousData.ARABICA)) * 100).toFixed(2) : 'N/A',
      robusta: previousData.ROBUSTA ? ((difference.robusta / Number(previousData.ROBUSTA)) * 100).toFixed(2) : 'N/A',
      total: sumOfPreviousReports ? ((difference.total / sumOfPreviousReports) * 100).toFixed(2) : 'N/A'
    }

    const currentMonth = currentData.MONTH?.split('-')[0]
    const previousMonth = previousData.MONTH?.split('-')[0]

    const currentMonthYear = `${currentMonth} - ${currentYear}`
    const previousMonthYear = previousData ? `${previousMonth} - ${previousYear}` : ''

    const dynamicTitle = modalType === 'total' ? `Upto ${currentMonthYear} To ${previousMonthYear} Comparison` : `${currentMonthYear} To ${previousMonthYear} Comparison`

    return (
      <div className="comparison-table" data-testid="uganda-comparison-dialog-modal">
        <div className="content-title" data-testid="comparison-title">
          <h5>{dynamicTitle}</h5>
        </div>

        <div className="table-container" data-testid="comparison-table">
          <div className="left-table-content" data-testid="comparison-left-table-content">
            <table>
              <thead>
                <tr>
                  <th>{t('MONTH')}</th>
                </tr>
              </thead>
              <tbody>
                <tr className="empty-table-row"></tr>
                <tr onMouseEnter={() => handleMouseEnter(0)} onMouseLeave={handleMouseLeave} className={hoveredRowIndex === 0 ? 'highlight' : ''} data-testid="current-data-month">
                  <td>{modalType === 'total' ? createMonthRange(currentData.MONTH) : currentData.MONTH}</td>
                </tr>

                <tr onMouseEnter={() => handleMouseEnter(1)} onMouseLeave={handleMouseLeave} className={hoveredRowIndex === 1 ? 'highlight' : ''} data-testid="previous-data-month">
                  {modalType === 'total' ? <td>{createMonthRange(previousData ? previousData.MONTH : '')}</td> : <td>{previousData ? previousData.MONTH : ''}</td>}
                </tr>

                <tr className="empty-table-row"></tr>

                <tr className="difference-row" data-testid="comparison-difference-row">
                  <td className="table-border">{t('DIFFERENCE')}</td>
                </tr>
                <tr className="percentage-row" data-testid="comparison-percentage-row">
                  <td className="table-border">{t('PERCENTAGE_WISE')}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="right-table-content" data-testid="comparison-right-table-content">
            <table>
              <thead>
                <tr>
                  <th>{t('ROBUSTA_COFFEE_REPORTS')}</th>
                  <th>{t('ARABICA_COFFEE_REPORTS')}</th>
                  <th>{t('TOTAL')}</th>
                </tr>
              </thead>
              <tbody>
                <tr className="empty-table-row"></tr>
                <tr onMouseEnter={() => handleMouseEnter(0)} onMouseLeave={handleMouseLeave} className={hoveredRowIndex === 0 ? 'highlight' : ''} data-testid="current-data-container">
                  <td>{displayValue(currentData.ROBUSTA)}</td>
                  <td>{displayValue(currentData.ARABICA)}</td>
                  <td>{displayValue(sumOfCurrentReports)}</td>
                </tr>
                <tr onMouseEnter={() => handleMouseEnter(1)} onMouseLeave={handleMouseLeave} className={hoveredRowIndex === 1 ? 'highlight' : ''} data-testid="previous-data-container">
                  <td>{displayValue(previousData.ROBUSTA)}</td>
                  <td>{displayValue(previousData.ARABICA)}</td>
                  <td>{displayValue(sumOfPreviousReports)}</td>
                </tr>
                <tr className="empty-table-row"></tr>
                <tr className="difference-row" data-testid="comparison-difference-container">
                  <td className={`${getTextColor(difference.robusta)} table-border`}>{displayValue(difference.robusta)}</td>
                  <td className={`${getTextColor(difference.arabica)} table-border`}>{displayValue(difference.arabica)}</td>
                  <td className={`${getTextColor(difference.total)} table-border`}>{displayValue(difference.total)}</td>
                </tr>
                <tr className="percentage-row" data-testid="comparison-percentage-container">
                  <td className={`${getTextColor(percentageDifference.robusta)} table-border`}>{percentageDifference.robusta !== 'N/A' ? `${percentageDifference.robusta}%` : 'N/A'}</td>
                  <td className={`${getTextColor(percentageDifference.arabica)} table-border`}>{percentageDifference.arabica !== 'N/A' ? `${percentageDifference.arabica}%` : 'N/A'}</td>
                  <td className={`${getTextColor(percentageDifference.total)} table-border`}>{percentageDifference.total !== 'N/A' ? `${percentageDifference.total}%` : 'N/A'}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="horizontal-scroll-container" id="port-wise-stock-report" data-testid="country-wise-data-uganda-component">
      {fetchedData?.map(({ report, year }, index) => {
        const { ROBUSTA, ARABICA } = calculateTotals(report)
        const sumOfTotals = ROBUSTA + ARABICA

        return (
          <div key={index} className="table-wrapper" data-testid="uganda-table-wrapper">
            <table>
              <thead>
                <tr className="year-row" data-testid="uganda-year-row">
                  <td colSpan={6}>
                    <div>{year}</div>
                  </td>
                </tr>
                <tr>
                  <th className="month">{t('MONTH')}</th>
                  <th className="roubsta">{t('ROBUSTA_COFFEE_REPORTS')}</th>
                  <th className="arabica">{t('ARABICA_COFFEE_REPORTS')}</th>
                  <th className="total">{t('TOTAL')}</th>
                </tr>
                <tr className="table-row-empty"></tr>
              </thead>
              <tbody style={checkForUserAccess(menuLock)}>
                {report.map(({ MONTH, ROBUSTA, ARABICA }, index) => {
                  const sumOfReports = Number(ROBUSTA) + Number(ARABICA)

                  return (
                    <tr key={index}>
                      <td>
                        <div className="popup-wrapper" onClick={() => userDetails && !menuLock && showMonthValueModal(index, year)} data-testid="popup-wrapper-container">
                          <div data-testid="month-container">{MONTH}</div>
                          <div className="icon-wrapper">
                            <img src={popupIcon} alt={MONTH} className="popup-icon" title="popup-icon-image" />
                          </div>
                        </div>
                      </td>

                      <td data-testid="robusta-container">{displayValue(ROBUSTA) || '--'} </td>
                      <td data-testid="arabica-container">{displayValue(ARABICA) || '--'}</td>
                      <td data-testid="sum-of-reports-container">{displayValue(sumOfReports) || '--'}</td>
                    </tr>
                  )
                })}
                <tr className="no-data-row"></tr>

                <tr className="tr-color" data-testid="uganda-total-row">
                  <td>
                    <div className="popup-wrapper" onClick={() => userDetails && !menuLock && showTotalValueModal(year)} data-testid="total-popup-wrapper">
                      <div>{t('TOTAL')}</div>
                      <div className="icon-wrapper">
                        <img src={popupIcon} alt={'icon'} className="popup-icon" title="total-popup-icon-image" />
                      </div>
                    </div>
                  </td>
                  <td data-testid="total-robusta-container">{displayValue(ROBUSTA)}</td>
                  <td data-testid="total-arabica-container">{displayValue(ARABICA)}</td>
                  <td data-testid="total-sum-of-reports-container">{displayValue(sumOfTotals)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )
      })}

      <Toast ref={toast} position="top-right" />

      <DialogUIModal title={modalType === 'total' ? t('TOTAL_COMPARISON_DATA') : t('MONTH_COMPARISON_DATA')} showModal={showModal} handleClose={() => setShowModal(false)} bodyContent={comparisonTableData} titlePosition="center" size="lg" testId="uganda-country" />
    </div>
  )
}
